import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/base-pages/content/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/breadcrumb/index.tsx");
